import { gql } from '@apollo/client';

export const GET_VOLUME_FORECAST = gql`
    query GetVolumeForecast($warehouseId: Long!, $areaId: Long!, $forecastDate: String!) {
        getVolumeForecast(warehouseId: $warehouseId, areaId: $areaId, forecastDate: $forecastDate)
    }
`;

export interface GetVolumeForecastResponse {
    getVolumeForecast: number | null;
}

export interface GetVolumeForecastVariables {
    warehouseId: number;
    areaId: number;
    forecastDate: string;
}
